import './index.css';
import App from './App';
import msalInstance from './services/sso';
import { MsalProvider } from '@azure/msal-react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap';

window.bootstrap = bootstrap;
const root = createRoot(document.getElementById('root'));

// This is critical to move inProgress from 'handleRedirect' to 'none'
msalInstance.initialize().then(() => {
  root.render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );
});